<template>
    <div>
        <el-container direction="vertical">
            <div class="divClass">
                <div>
                    <el-form label-width="80px" :inline="true" style="margin-top: 20px;margin-left: 20px;"
                        v-loading="formLoading" label-position="left">
                        <el-form-item label="按责任医师">
                            <el-checkbox v-model="isResponseManage"
                                @change="responseManageCheckChange">推荐管理</el-checkbox>
                        </el-form-item>
                        <el-form-item label="联系方式" style="margin-left: 50px;">
                            <el-select v-model="patientHavePhone" placeholder="请选择是否有联系方式">
                                <el-option label="全部" value="全部"></el-option>
                                <el-option label="有" value="有"></el-option>
                                <el-option label="无" value="无"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="患者姓名" style="margin-left: 50px;">
                            <el-input v-model="listQuery.name"></el-input>
                        </el-form-item>
                        <el-form-item label="按病种">
                            <el-switch v-model="riskLevelDanger" active-text="高危" inactive-text="确诊"
                                style="margin-bottom: 2px;">
                            </el-switch>
                            <span style="color: red;margin-left: 16px;">
                                <el-tag type="danger" style="font-size: 14px;">提示：该选项需要选择以下病种进行筛查</el-tag>
                            </span>
                            <br />
                            <el-radio-group v-model="diseaseCategorySelected" style="width: 700px;margin-left: 0px;">
                                <el-radio v-for="(item, index) in diseaseCategoryOptions" :key="index"
                                    :label="item.label" :value="item.value">{{ item.label }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="来院时间">
                            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="margin-left: 50px" @click="submitForm">查询</el-button>
                            <el-button @click="resetSetting">重置</el-button>
                            <el-button @click="reportExportToExcel">导出</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <el-table ref="multipleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
                    style="width: 100%; margin-left: 0px;">
                    <el-table-column align="center" label="姓名" width="80">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="性别" width="60">
                        <template slot-scope="scope">
                            <span>{{ getGender(scope.row.gender) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="年龄" width="60">
                        <template slot-scope="scope">
                            <span>{{ getAge(scope.row.birthday) }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column width="170px" align="center" label="身份证号" min-width="180">
                        <template slot-scope="scope">
                            <span>{{ scope.row.idcard }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="疾病标签" width="160">
                        <template slot-scope="scope">
                            <span :class="scope.row.label0">糖</span>
                            <span :class="scope.row.label1">压</span>
                            <span :class="scope.row.label2">尿</span>
                            <span :class="scope.row.label3">脂</span>
                            <span :class="scope.row.label4">重</span>
                            <span :class="scope.row.label5">肺</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="更新时间" width="140">
                        <template slot-scope="scope">
                            <span>{{ getStandardDate(scope.row.updateTime) }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="联系方式" width="110">
                        <template slot-scope="scope">
                            <span>{{ scope.row.phone }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="一体化方案" min-width="90">
                        <template slot-scope="scope">
                            <span>{{ scope.row.integratePersonPlanName || '-' }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" align="center" label="操作" width="220">
                        <template slot-scope="scope">
                            <el-button style="margin-left: 0px; align-self: center" type="text"
                                @click="patientsDetail(scope.row)">
                                健康档案
                            </el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="patientIntegrationDetail(scope.row)">
                                一体化方案
                            </el-button>

                            <!-- <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="patientsAnnualEvaluation(scope.row)">
                                年度评估
                            </el-button> -->

                            <!-- <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="patientsDetail(scope.row)">
                                转移管理
                            </el-button> -->
                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="handleTransferManagement(scope.row)">
                                转移管理
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize" @pagination="turnToPage" style="margin-top: 0px;" />

                <edit-patient v-if="editPatientVisible" ref="editPatientRef"></edit-patient>

                <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>

                <patient-record v-if="patientRecordVisible" ref="PatientRecordRef"></patient-record>

                <transfer-management v-if="transferManagementVisible" ref="transferManagementRef"></transfer-management>

                <add-patient v-if="addPatientVisible" ref="addPatientRef" @closeAdd="closeDialog"></add-patient>

                <patient-integration-detail v-if="patientIntegrationDetailVisible" ref="patientIntegrationDetailRef" />

                <annual-evaluation-detail v-if="annualEvaluationDetailVisible"
                    ref="annualEvaluationDetailRef"></annual-evaluation-detail>

            </div>
        </el-container>
    </div>
</template>
<script>
import {
    getSearchList,
    getSearchListByLabel,
    turnToPageList,
    turnToPageListByLabel,
    delPatientList,
    getlistEhrDepts,
    getByIdPatientDetail,
    addContactList,
    reportToExcel,
    getSolrSearchList,
    turnToSolrPageList,
    getSysDicList,
    getUserInfos,
    addIntegrateManage,
} from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import addPatient from "@/views/patient/addPatient";
import editPatient from "@/views/patient/editPatient";
import patientDetail from "@/views/patient/patientDetail";
import patientRecord from "@/views/patient/patientRecord";
import transferManagement from "@/views/patient/transferManagement";
import SelectTree from "@/components/selectTree";
import { Loading } from "element-ui";
import moment from "moment";
import patientIntegrationDetail from "../../integrationManagement/patientIntegrationDetail.vue";
import annualEvaluationDetail from "../../annualEvaluation/annualEvaluationDetail.vue";

export default {
    components: {
        Pagination,
        patientDetail,
        patientRecord,
        SelectTree,
        addPatient,
        editPatient,
        transferManagement,
        patientIntegrationDetail,
        annualEvaluationDetail
    },
    data() {
        return {
            //div:style="{width: screenWidth+'px'}"
            screenWidth: 1000,
            patientDetailVisible: false,
            patientRecordVisible: false,
            transferManagementVisible: false,
            addPatientVisible: false,
            editPatientVisible: false,
            patientIntegrationDetailVisible: false,
            annualEvaluationDetailVisible: false,
            data: [],
            list: null,
            total: 0,
            listLoading: false,
            formLoading: false,
            valueData: null,
            birthdayData: null,
            loadingOptions: {
                text: "正在导出...",
                background: "rgba(0, 0, 0, 0.6)",
            },
            doctorDept: null,
            doctorName: null,
            listQuery: {
                visitTimeStart: null,
                visitTimeEnd: null,
                pageNum: 0,
                pageSize: 10,
                labels: [],
                integrateManageStatus: "已管理",
                name: null
            },
            patientHavePhone: '全部',
            riskLevelDanger: false,
            dangerLevelChencked: false,
            diseaseCategorySelected: null,
            inLabelsSelected: [],
            multipleSelection: [],
            isResponseManage: false,
            doctorManageRules: null,
            relationList: ["与", "或", "非"],
            typeList: [
                "高血压",
                "糖尿病",
                "高血脂",
                "慢阻肺",
                "冠心病",
                "脑卒中",
                "肾病综合征",
                "眼底病变",
                "周围神经病变",
                "周围血管病变",
            ],
            preTypeList: ["高血压", "糖尿病", "高血脂", "慢阻肺"],
            postTypeList: [
                "冠心病",
                "脑卒中",
                "肾病综合征",
                "眼底病变",
                "周围神经病变",
                "周围血管病变",
            ],
            managerHospitalList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            domains: [
                {
                    relation: "",
                    value: "",
                },
            ],
            labelDomains: [
                {
                    label: "",
                    labelData: "",
                },
            ],
            diseaseCategoryOptionsDanger: [
                {
                    value: '{"label": "diabet_danger","filter":"and","operator":"in"}',
                    label: "糖尿病",
                },
                {
                    value: '{"label": "hyper_danger","filter":"and","operator":"in"}',
                    label: "高血压",
                },
                {
                    value: '{"label": "hyperuricemia_danger","filter":"and","operator":"in"}',
                    label: "高尿酸",
                },
                {
                    value: '{"label": "bloodfat_danger","filter":"and","operator":"in"}',
                    label: "高血脂",
                },
                {
                    value: '{"label": "overweight","filter":"and","operator":"in"}',
                    label: "高体重",
                },
                {
                    value: '{"label": "copd","filter":"and","operator":"in"}',
                    label: "慢阻肺",
                },
                {
                    value: '{"label": "lungcancer_danger","filter":"and","operator":"in"}',
                    label: "肺癌管理",
                }
            ],
            diseaseCategoryOptions: [
                {
                    value: '{"label": "diabet","filter":"and","operator":"in"}',
                    label: "糖尿病",
                },
                {
                    value: '{"label": "hyper","filter":"and","operator":"in"}',
                    label: "高血压",
                },
                {
                    value: '{"label": "hyperuricemia","filter":"and","operator":"in"}',
                    label: "高尿酸",
                },
                {
                    value: '{"label": "bloodfat","filter":"and","operator":"in"}',
                    label: "高血脂",
                },
                {
                    value: '{"label": "overweight","filter":"and","operator":"in"}',
                    label: "高体重",
                },
                {
                    value: '{"label": "copd","filter":"and","operator":"in"}',
                    label: "慢阻肺",
                },
                {
                    value: '{"label": "lungcancer","filter":"and","operator":"in"}',
                    label: "肺癌管理",
                }
            ],
            inLabelsOptions: [
                {
                    value: "overweight",
                    label: "高体重",
                },

                {
                    value: "easy_lungcancer",
                    label: "肺癌易患",
                },
                {
                    value: "cancer",
                    label: "肿瘤",
                },
                {
                    value: "cad",
                    label: "冠心病",
                },
                {
                    value: "stroke",
                    label: "脑卒中",
                },
                {
                    value: "heartfailure",
                    label: "心力衰竭",
                },
                {
                    value: "fat",
                    label: "肥胖",
                },
                {
                    value: "bloodfat",
                    label: "高血脂",
                },
                {
                    value: "diabet_danger",
                    label: "糖尿病高危",
                },
                {
                    value: "hyper_danger",
                    label: "高血压高危",
                },
                {
                    value: "bloodfat_danger",
                    label: "高血脂高危",
                },
                {
                    value: "easy_hyperuricemia",
                    label: "尿酸高危",
                },

                {
                    value: "easy_lungcancer",
                    label: "肺癌高危",
                },
                {
                    value: "easy_hyper",
                    label: "高血压易患",
                },
                {
                    value: "easy_diabet",
                    label: "糖尿病易患",
                },
                {
                    value: "hyper",
                    label: "高血压确诊",
                },
                {
                    value: "diabet",
                    label: "糖尿病确诊",
                },
                {
                    value: "copd",
                    label: "慢阻肺确诊",
                },
                {
                    value: "lungcancer",
                    label: "肺癌确诊",
                },
                {
                    value: "hyperuricemia",
                    label: "高尿酸血症确诊",
                }
            ],
            filterLabelsOptions: [
                {
                    value: "diabet_level",
                    label: "血糖检测红黄绿等级",
                },
                {
                    value: "hypertension_level",
                    label: "血压检测红黄绿等级",
                }
            ],
            filterLabelsLevelOptions: [
                {
                    value: "1",
                    label: "绿",
                },
                {
                    value: "2",
                    label: "黄",
                },
                {
                    value: "3",
                    label: "红",
                }
            ],
            exportBody: {
                url: "/business/ehr/searchByLabel",
                headers: [
                    "姓名",
                    "性别",
                    "出生年月",
                    "身份证号",
                    "最后来院时间",
                    "电话号码"
                ],
                keys: [
                    "name",
                    "gender",
                    "birthday",
                    "idcard",
                    "updateTime",
                    "phone"
                ],
                body: null,
            },
            sexOptions: []
        };
    },
    created() {
        this.screenWidth = window.__POWERED_BY_QIANKUN__ ? 1000 : 1200;
        var typeData = "性别";
        this.getSystemDictList(typeData);
        this.getDcotorDept();
        this.submitForm();
    },
    methods: {
        //一体化方案
        patientIntegrationDetail(row) {
            this.patientIntegrationDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["patientIntegrationDetailRef"].init(row);
            });
        },
        //转移管理
        handleTransferManagement(row) {
            this.transferManagementVisible = true;
            this.$nextTick(() => {
                this.$refs["transferManagementRef"].init(row);
            });
        },
        //年度评估
        patientsAnnualEvaluation(row) {
            this.annualEvaluationDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["annualEvaluationDetailRef"].init(row);
            });
        },
        responseManageCheckChange() {
            this.submitForm();
        },
        // 获取医生科室名称
        getDcotorDept() {
            let params = {}
            getUserInfos(params).then((res) => {
                if ((res.msg == "success")) {
                    this.doctorDept = res.data.deptName;
                    this.doctorName = res.data.name;
                    this.getRulesforDistribution();
                    // this.submitForm();
                } else {
                    // this.submitForm();
                }
            });
        },
        //获取分配规则
        getRulesforDistribution() {
            if (this.doctorDept == "内分泌与代谢性疾病科") {
                var rules = {
                    filterLabels: [
                        {
                            label: "diabet",
                            filter: "or",
                            operator: "in"
                        },
                        {
                            label: "hyperuricemia",
                            filter: "or",
                            operator: "in"
                        },
                        {
                            label: "bloodfat",
                            filter: "or",
                            operator: "in"
                        },
                        {
                            filter: "or",
                            filterLabels: [
                                {
                                    label: "diabet",
                                    filter: "and",
                                    operator: "not"
                                },
                                {
                                    label: "hyperuricemia",
                                    filter: "and",
                                    operator: "not"
                                },
                                {
                                    label: "bloodfat",
                                    filter: "and",
                                    operator: "not"
                                },
                                {
                                    label: "bloodpressure",
                                    filter: "and",
                                    operator: "not"
                                },
                                {
                                    label: "diabet danger",
                                    filter: "and",
                                    operator: "in"
                                },
                                {
                                    label: "overweight",
                                    filter: "and",
                                    operator: "in"
                                }
                            ]
                        }
                    ]
                };
                this.doctorManageRules = rules;
            } else if (this.doctorDept == "老年医学科") {
                var rules = {
                    filterLabels: [
                        {
                            label: "hyper",
                            filter: "or",
                            operator: "in"
                        },
                        {
                            filter: "or",
                            filterLabels: [
                                {
                                    label: "diabet",
                                    filter: "and",
                                    operator: "not"
                                },
                                {
                                    label: "bloodfat",
                                    filter: "and",
                                    operator: "not"
                                },
                                {
                                    label: "hyperuricemia",
                                    filter: "and",
                                    operator: "not"
                                },
                                {
                                    label: "hyper",
                                    filter: "and",
                                    operator: "in"
                                }
                            ]
                        }
                    ]
                };
                this.doctorManageRules = rules;
            } else {
                this.doctorManageRules = null;
            }
        },
        //查询结果导出
        reportExportToExcel() {
            console.log(
                "查询结果导出",
                `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
            );

            let loadingInstance = Loading.service(this.loadingOptions);

            this.exportBody.url =
                "/business/ehr/searchByLabel?page=" +
                this.listQuery.pageNum +
                "&pageSize=" +
                this.listQuery.pageSize;

            this.exportBody.body = this.listQuery;
            console.log("导出表格请求body：", this.exportBody);

            reportToExcel(this.exportBody)
                .then((res) => {
                    console.log("查询表格导出====", res);

                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    let blob = new Blob([res], { type: "application/force-download" });
                    console.log(blob);
                    let fileReader = new FileReader();
                    fileReader.readAsDataURL(blob);
                    fileReader.onload = (e) => {
                        let a = document.createElement("a");
                        a.download = `标签档案${moment(new Date()).format(
                            "YYYYMMDDHHmm"
                        )}.xlsx`;
                        a.href = e.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                })
                .catch((error) => {
                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    console.log(error);

                    this.$message({
                        message: "导出失败",
                        type: "error",
                    });
                });
        },
        patientsListIncludeContactsClick() {

        },
        patientsListIncludeManagementClick() {

        },
        selectAllClick() {
            if (this.list) {
                this.list.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            }
        },
        cancelSelected() {
            this.$refs.multipleTable.clearSelection();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        resetSetting() {
            this.listQuery = {
                visitTimeStart: null,
                visitTimeEnd: null,
                pageNum: 0,
                pageSize: 10,
                labels: [],
                integrateManageStatus: "已管理",
                name: null
            };

            this.inLabelsSelected = [];
            this.dangerLevelChencked = false;
            this.diseaseCategorySelected = null;
            this.isResponseManage = false;
            this.riskLevelDanger = false;
            this.patientHavePhone = "全部";
            this.submitForm();
        },
        getSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sexOptions = records;
            }).catch(err => {
                console.log(err);
            })
        },
        getGender(gender) {
            var option = this.sexOptions.filter(v => v.value == gender)[0];
            return option.name;
        },
        // 获取机构数组
        input(value) {
            // this.listQuery.managerHospitals = value;
        },
        setLabel0(item) {
            //糖尿病
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "diabet");
                const isIncluded2 = labels.some(dt => dt.label === "diabet_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_diabet");

                if (!this.riskLevelDanger && isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel1(item) {
            //高血压
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "hyper");
                const isIncluded2 = labels.some(dt => dt.label === "hyper_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyper");

                if (isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel2(item) {
            //高尿酸
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "hyperuricemia");
                const isIncluded2 = labels.some(dt => dt.label === "hyperuricemia_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyperuricemia");

                if (isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel3(item) {
            //高血脂
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "bloodfat");
                const isIncluded2 = labels.some(dt => dt.label === "bloodfat_danger");
                if (isIncluded1) {
                    return "labelRed"
                }
                if (isIncluded2) {
                    return "labelRedCircle"
                }

            } else {
                return "labelNone";
            }
        },
        setLabel4(item) {
            //高体重
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "overweight");

                if (isIncluded1) {
                    return "labelRed"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel5(item) {
            //慢阻肺 肺癌管理
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "lungcancer");
                const isIncluded2 = labels.some(dt => dt.label === "lungcancer_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_lungcancer");

                if (isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        // 关闭新建弹窗
        closeDialog(value) {
            console.log("关闭新建弹窗", value);
            this.addPatientVisible = value;
        },
        // 新建病人档案
        addPatient() {
            this.addPatientVisible = true;
            var value = this.addPatientVisible;
            this.$nextTick(() => {
                this.$refs.addPatientRef.init(value);
            });
        },
        // 将该患者设置为户主
        setHouseholder(value) {
            if (value.isHeadFamily == "1") {
                this.$message({
                    message:
                        "已经有以此人为户主的家庭档案信息存在！请转往家庭档案处查看。",
                    type: "warning",
                });
                return;
            }
            this.$confirm(
                "此操作将在家庭档案中以此人为户主建立家庭档案信息, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    var contactParams = {
                        idcard: value.idcard,
                        name: value.name,
                        phone: value.phone,
                        relationCode: "0",
                        relationName: "本人或户主",
                        householderIdcard: value.idcard
                    };

                    addContactList(contactParams)
                        .then((res) => {
                            if (res.msg == "success") {
                                this.$message({
                                    message: "设置成功！",
                                    type: "success",
                                });
                            }
                            this.submitForm();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消设置",
                    });
                });
        },
        // 删除病人档案
        delPatient(value) {
            this.$confirm("此操作将删除该档案信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const patientData = {
                        id: value.id,
                    };
                    this.listLoading = true;
                    delPatientList(patientData).then((res) => {
                        this.listLoading = false;
                        if (res.msg == "success") {
                            this.$message({
                                message: "删除成功！",
                                type: "success",
                            });
                            // 更新视图列表
                            this.turnToPage();
                        } else {
                            this.$message({
                                message: "删除失败！",
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 查询健康列表
        submitForm() {
            // console.log("检索条件：", this.domains);

            this.listLoading = true;
            if (this.valueData != null) {
                this.listQuery.visitTimeStart = this.getParseDate(this.valueData[0], 1);
                this.listQuery.visitTimeEnd = this.getParseDate(this.valueData[1], 2);
            } else {
                this.listQuery.visitTimeStart = null;
                this.listQuery.visitTimeEnd = null;
            }

            this.listQuery.labels = [];

            console.log("按责任医师：", this.isResponseManage, this.doctorManageRules);

            if (this.isResponseManage) {
                this.listQuery.labels.push(this.doctorManageRules);
            }

            console.log("按病种：", this.diseaseCategorySelected);
            if (this.diseaseCategorySelected != null) {
                var item;
                if (this.riskLevelDanger) {
                    //高危
                    item = this.diseaseCategoryOptionsDanger.find(item => item.label === this.diseaseCategorySelected);

                } else {
                    //确诊
                    item = this.diseaseCategoryOptions.find(item => item.label === this.diseaseCategorySelected);
                }
                console.log("按病种：", item);
                var itemDic = JSON.parse(item.value);
                this.listQuery.labels.push(itemDic);
            }

            // limitLabels 筛选标签，有条件后会返回单一病种数据
            this.listQuery.limitLabels = this.listQuery.labels?.map(x => x.label) || [];

            if (this.doctorName == "韩明宏") {
                var limitLabels = ["lungcancer", "lungcancer_danger"];
                this.listQuery.limitLabels = limitLabels;
            }

            if (this.patientHavePhone == "全部") {
                this.listQuery.mobileExist = null;
            } else if (this.patientHavePhone == "有") {
                this.listQuery.mobileExist = true;
            } else if (this.patientHavePhone == "无") {
                this.listQuery.mobileExist = false;
            }

            getSearchListByLabel(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 导航跳转查询列表页
        turnToPage() {
            this.listLoading = true;
            if (this.valueData != null) {
                this.listQuery.visitTimeStart = this.getParseDate(
                    this.valueData[0],
                    1
                );
                this.listQuery.visitTimeEnd = this.getParseDate(this.valueData[1], 2);
            } else {
                this.listQuery.visitTimeStart = null;
                this.listQuery.visitTimeEnd = null;
            }

            turnToPageListByLabel(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            this.patientDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });
        },
        // 编辑个人档案
        patientsEdit(row) {
            let params = {
                id: row.id,
            };
            getByIdPatientDetail(params)
                .then((res) => {
                    if (res.msg == "success") {
                        // console.log("========", res, row);
                        var data = res.data;
                        this.editPatientVisible = true;
                        this.$nextTick(() => {
                            this.$refs["editPatientRef"].init(data);
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return (
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date)
            );
        },
        getStandardDate(dateString) {
            const formattedDate = moment(dateString).format('YYYY-MM-DD HH:mm');
            return formattedDate;
        },
        // 身份证号加密
        formatIDcard(card) {
            if (card == null) return "";

            var str = card;
            str = str.toString().replace(/^(.{3})(?:\w+)(.{4})$/, "$1***********$2");
            return str;
        },
        // 手机号加密
        formatPhone(card) {
            if (card == null) return "";

            var str = card;
            if (str.length == 11) {
                str = str.toString().replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
                return str;
            } else if (str.length == 8) {
                str =
                    str.toString().substring(0, 2) + "****" + str.substr(str.length - 2);
                return str;
            } else {
                return str;
            }
        },
        // 计算当前年龄
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        },
    },
};
</script>
<style lang="scss" scoped>
.divClass {
    background-color: rgb(255, 255, 255);
    border: 1px solid #eee;
}

.listQuery {
    display: flex;
    flex-wrap: wrap;
    margin-top: 22px;
}

// .labelRed {
//     border-radius: 50%;
//     color: white;
//     background: red;
//     padding: 1px;
// }

.labelRed {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
}

.labelRedCircle {
    border: 1px solid red;
    background: #fff;
    color: red;
    padding: 2px;
    border-radius: 50%;
}

.labelBlue {
    border-radius: 50%;
    color: white;
    background: blue;
    padding: 3px;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelPurple {
    border: 1px solid purple;
    background: purple;
    color: #fff;
    padding: 2px;
    border-radius: 50%;
}

.labelNone {
    display: none;
}

::v-deep .el-form {

    // .el-input__inner {
    //   width: 250px;
    // }
    .el-input {
        width: 200px;
    }

    .el-date-editor {
        width: 250px;
    }

    .el-form-item__label {
        width: 90px !important;
    }

    .el-form-item:last-child .el-form-item__content {
        display: flex;
    }
}
</style>